import React from "react"
import Icon from "../Icon/Icon"
import ReactTooltip from "react-tooltip"

const APPLICATION_PREFILL_DOCS_URL =
	"https://www.unit.co/docs/ready-to-launch/banking/advanced-implementation/pre-filling-user-information/"
const USER_MANAGEMENT_DOCS_URL =
	"https://www.unit.co/docs/ready-to-launch/banking/advanced-implementation/multi-user-access/#api-endpoint-requirements"

export default function CallbacksFields({
	endUserConfigUrl,
	findEndUsersUrl,
	bankingPageUrl,
	updateSettings,
}: {
	endUserConfigUrl?: string
	findEndUsersUrl?: string
	bankingPageUrl?: string
	updateSettings: (field: string, value: string) => void
}) {
	return (
		<fieldset className="fields">
			<div className="field">
				<label className="label label-with-tooltip">
					Application Prefill Endpoint
					<div data-tip data-for="application-prefill-info" className="tooltip-info callbacks-tooltip-trigger">
						<Icon icon="information-circle--interface-essential" size={12} />
					</div>
					<ReactTooltip
						className="tooltip-info"
						id="application-prefill-info"
						effect="solid"
						event="click"
						globalEventOff="click"
						clickable={true}
					>
						<span>
							Read more about application prefill in our{" "}
							<a
								href={APPLICATION_PREFILL_DOCS_URL}
								target="_blank"
								rel="noopener noreferrer"
								style={{color: "#FFFFFF", textDecoration: "underline"}}
							>
								docs
							</a>
							.
						</span>
					</ReactTooltip>
				</label>
				<div className="control">
					<input
						className="input"
						type="text"
						placeholder="Enter URL"
						value={endUserConfigUrl ?? ""}
						onChange={(e) => {
							updateSettings("endUserConfigUrl", e.target.value)
						}}
					/>
				</div>
			</div>
			<div className="field">
				<label className="label label-with-tooltip">
					User Management Endpoint
					<div data-tip data-for="user-management-info" className="tooltip-info callbacks-tooltip-trigger">
						<Icon icon="information-circle--interface-essential" size={12} />
					</div>
					<ReactTooltip
						className="tooltip-info"
						id="user-management-info"
						effect="solid"
						event="click"
						globalEventOff="click"
						clickable={true}
					>
						<span>
							Read more about user management in our{" "}
							<a
								href={USER_MANAGEMENT_DOCS_URL}
								target="_blank"
								rel="noopener noreferrer"
								style={{color: "#FFFFFF", textDecoration: "underline"}}
							>
								docs
							</a>
							.
						</span>
					</ReactTooltip>
				</label>
				<div className="control">
					<input
						className="input"
						type="text"
						placeholder="Enter URL"
						value={findEndUsersUrl ?? ""}
						onChange={(e) => {
							updateSettings("findEndUsersUrl", e.target.value)
						}}
					/>
				</div>
			</div>
			<div className="field">
				<label className="label label-with-tooltip">Banking Page URL</label>
				<div className="control">
					<input
						className="input"
						type="text"
						placeholder="Enter URL"
						value={bankingPageUrl ?? ""}
						onChange={(e) => {
							updateSettings("bankingPageUrl", e.target.value)
						}}
					/>
				</div>
			</div>
		</fieldset>
	)
}
